import React, { useEffect, useState } from 'react'
import {getCategoryDiscountApi, getProductDetailApi } from '../../Api/BarestSupplierServices'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import Style from './DiscountOneProduct.module.css'
import LoadingComponet from '../../Components/LoadingComponet/LoadingComponet'
import EachProductDiscount from '../../Components/EachProductDiscount/EachProductDiscount'
import SearchBar from '../../Components/SearchBar/SearchBar'
import InfiniteScroll from 'react-infinite-scroller'
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading'

const DiscountOneProduct = () => {
    const[data,setData]=useState([])
    const[products,setProducts]=useState()
    // const[, setIndex]=useState()
    const[search,setSearch]=useState('')
    // const[, setClick]=useState(false)

    const[hasMoreItems,setHasMoreItems]=useState(true)
    const[item,setItem]=useState(5)

    useEffect(()=>{
        getMenuCategory()
        getProductDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    
    ////////////////بخش گرفتن دسته بندی ها در منو
    const getMenuCategory =async()=>{
        const result=await getCategoryDiscountApi()
        setData(result.category)
    }
    
    /////////// گرفتن دیتای جزییات محصول 
    const getProductDetail=()=>{
        const info={
            exist:1,
            category_id:data.id
        }
        getProductDetailApi(info,(suc)=>{
            if(suc){
                setProducts(suc.products.reverse())
            } 
            else{
                <LoadingComponet/>
            }
        })
    }
    ////کلیک کردن روی ایتم های منو
    // const categoryHandle=(id)=>{
            
    //     let info={
    //         exist:1,
    //         category_id:id
    //     }

    //     getProductDetailApi(info,(res)=>{
    //         if(res.status===1){
    //             setProducts(res.products.reverse())
    //         } 
    //         else{
    //             console.log("error")
    //         }
    //     })
        
    //     setClick(true)
    //     setIndex(id)
    // }
    let subset =products&&products.slice(0,item)
    const loadMore=()=> {
        if(item===products.length||item>=products.length)
        {
            setHasMoreItems(false)
        }
        else{
            setTimeout(() => {
                setItem(item + 5)
            }, 2000);
        }
    }
    let loading=null
    
    if(products===undefined){
        loading=<LoadingComponet/>
    }
    else{
        loading=
        <InfiniteScroll
            style={{width:"100%" , height:'100vh',display: "flex",justifyContent: "center"}}
            loadMore={loadMore}
            hasMore={hasMoreItems}
            loader={<PointSpreadLoading style={{height:"3rem" , marginInline:"auto"}}  color={'#ab0c59'}/>}
        >
            {subset.filter(value=>{
                if(value.filter===''){
                    return value 
                }
                else if(value.name.includes(search)){
                    return value
                }
                return false
                }).map((item,index)=>
                    <EachProductDiscount getProductDetail={getProductDetail} key={index} item={item}/>
                )}
        </InfiniteScroll>
    }
 
    return (
        <div className={Style.pageHolder}>
            <MenuTitle title={"تخفیف یک محصول"}/>
            <div className={Style.centerHolder}>
                {/* {data===undefined ?<LoadingComponet/> : <MenuProduct addProduct={false} click={click} categoryHandle={categoryHandle} setProducts={setProducts} index={index} setIndex={setIndex} data={data}/> } */}
                <SearchBar search={search} setSearch={setSearch}/>
                {loading}
            </div>  
        </div>
    )
}
export default DiscountOneProduct
